// extracted by mini-css-extract-plugin
module.exports = {"addNewButton":"CriterionList_addNewButton__1ZYqS float-right","infoTooltip":"CriterionList_infoTooltip__mUuny"};